import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import api from '@config/api.service';
import { loadStripe } from '@stripe/stripe-js';
import StripeForm from './StripeForm';

const StripeProvider = ({ handler, loading, setLoading, dialogAction }) => {
  const { stripeKey } = api;
  const stripePromise = loadStripe(stripeKey);
  return (
    <Elements stripe={stripePromise}>
      <StripeForm
        handler={handler}
        loading={loading}
        setLoading={setLoading}
        dialogAction={dialogAction}
      />
    </Elements>
  );
};

export default StripeProvider;

StripeProvider.propTypes = {
  handler: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  dialogAction: PropTypes.object,
};
